<template>
  <div v-if="snackbar" id="toast-container" class="toast-top-right">
    <div class="toast" aria-live="polite" style :class="color" @click="hideNotification">
      <div class="toast-progress" :style="{'width': progressPercent + '%'}" />

      <button type="button" class="toast-close-button" role="button">×</button>

      <div class="toast-message">{{ $t(message.title) }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { setTimeout, clearTimeout, clearInterval, setInterval } from 'timers';

export default {
  props: {
    x: {
      type: String,
      default: null
    },
    y: {
      type: String,
      default: 'top'
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      snackbar: false,
      timeoutId: undefined,
      intervalId: undefined,
      timer: 0
    };
  },
  methods: {
    hideNotification() {
      this.clearTimers();
      this.$store.dispatch('hideNotification');
    },
    showNext() {
      this.$store.dispatch('showNext');
    },
    clearTimers() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      if (this.intervalId) {
        this.timer = 0;
        clearInterval(this.intervalId);
      }
    },
    refreshProgress() {
      this.clearTimers();
      if (this.message.title) {
        this.timeoutId = setTimeout(() => {
          if (this.countMessages > 0) {
            this.showNext();
          } else {
            this.hideNotification();
          }
        }, this.timeout);

        this.intervalId = setInterval(() => {
          this.timer += 10;
        }, 10);
      }
    }
  },
  computed: {
    ...mapState({
      show: state => state.notification.show,
      message: state => state.notification.current.message,
      color: state => state.notification.current.color
    }),
    ...mapGetters(['countMessages']),
    progressPercent() {
      const percent = ((this.timeout - this.timer) / this.timeout) * 100;
      return Math.round(percent * 100) / 100;
    }
  },
  watch: {
    show(val) {
      this.snackbar = val;
    },
    countMessages(val) {
      this.refreshProgress();
    },
    'message.title'(val) {
      this.refreshProgress();
    },
    snackbar(val) {
      if (!val) {
        this.hideNotification();
      }
    }
  }
};
</script>
